import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import ToolPermissionsGroups from './ToolPermissionsGroups.jsx'
import { toolPermissionsTitle } from './toolPermissionsTitle.js'
import { useToolPermissionsEditor } from './useToolPermissionsEditor.js'
import styles from './toolPermissionsDialog.module.scss'

export default function ToolPermissionsDialog({ connectionId, onClose }) {
  const editor = useToolPermissionsEditor({ connectionId, onClose })
  return (
    <Dialog open={Boolean(connectionId)} onClose={editor.cancel} maxWidth={false} scroll="paper" slotProps={{ paper: { className: styles.paper, elevation: 0 } }}>
      <DialogTitle className={styles.title}>{toolPermissionsTitle(editor.data)}</DialogTitle>
      <DialogContent className={styles.content} dividers>
        <Typography className={styles.subtitle}>Choose which {editor.data?.toolkit_name ?? 'connection'} tools are always allowed across this agent.</Typography>
        {editor.loading ? <Typography className={styles.state}>Loading tools…</Typography> : null}
        {editor.error ? <Typography color="error">Could not load tool permissions.</Typography> : null}
        <ToolPermissionsGroups groups={editor.groups} onChange={editor.setTier} />
      </DialogContent>
      <DialogActions className={styles.actions}>
        <Button onClick={editor.cancel}>Cancel</Button>
        <Button variant="contained" onClick={editor.save} disabled={!editor.data || editor.saving}>Save changes</Button>
      </DialogActions>
    </Dialog>
  )
}
